// @flow
import {campaignId} from '../constants/appsConstants';
import AppsUtil from './AppsUtil';
import {DeviceDetectionUtil} from 'cchome-shared/utils';

const VARIATION_TYPE = {
	TEST_A: 'testA',
	TEST_B: 'testB',
	TEST : 'test',
	CONTROL : 'control',
	NA: 'na'
};
export const EXPERIENCE_TYPE = {
	ALL_APPS: 'all-apps-plan',
	PHOTO_PLAN: 'photo-plan',
	OTHER : 'other',
	NA: 'na'
};
const _campaignVariationMap = {}; // Map between campaign ID and variation (test, control, testA, testB etc)
const _campaignExperienceMap = {}; // Map between campaign ID and experience (all-apps, photo-plan, other etc)
const variableCampaign = {};

function findVariation(hashValue) {
	if (hashValue <= 33) {
		return VARIATION_TYPE.TEST_A;
	}
	if (33 < hashValue && hashValue <= 67) {
		return VARIATION_TYPE.CONTROL;
	}
	return VARIATION_TYPE.TEST_B;
}
function getVariationForKaizen() {
	if (AppsUtil.hasFeature('temp_cch_11582_testA')) {
		return VARIATION_TYPE.TEST_A;
	}
	if (AppsUtil.hasFeature('temp_cch_11582_testB')) {
		return VARIATION_TYPE.TEST_B;
	}
	return VARIATION_TYPE.CONTROL;
}

function _initVariationForCampaign(campaign: string) {
	let variation = VARIATION_TYPE.NA;
	let getHash;
	switch (campaign) {
		case 'dummyTest' :
			getHash = window.cchome.util.murmurHashUserId('');
			variation = getHash < 10 ? VARIATION_TYPE.TEST : VARIATION_TYPE.CONTROL;
			break;
		case campaignId.growthIntentSelection:
			getHash = window.cchome.util.murmurHashUserId('THROUGHLINE_TEST_SEED');
			variation = (getHash < 60 || AppsUtil.hasFeature('temp_bypass_throughline_test')) ? VARIATION_TYPE.TEST : VARIATION_TYPE.CONTROL;
			break;
		case campaignId.growthIntentSelectionPhotoshop:
			getHash = window.cchome.util.murmurHashUserId('THROUGHLINE_PHOTOSHOP_TEST_SEED');
			variation = (getHash < 50 || AppsUtil.hasFeature('temp_bypass_throughline_photoshop_test')) ? VARIATION_TYPE.TEST : VARIATION_TYPE.CONTROL;
			break;
		case campaignId.throughlineV3Ja:
			getHash = window.cchome.util.murmurHashUserId('THROUGHLINE_V3_TEST_SEED');
			variation = (getHash < 50 || AppsUtil.hasFeature('temp_bypass_throughline_v3_test')) ? VARIATION_TYPE.TEST : VARIATION_TYPE.CONTROL;
			break;
		case campaignId.throughlineV3En:
			variation = VARIATION_TYPE.TEST;
			break;
		case campaignId.categoryPageRevampTest:
			getHash = window.cchome.util.murmurHashUserId('CATEGORY_REVAMP_SEED');
			variation = (getHash >= 50) ? VARIATION_TYPE.TEST : VARIATION_TYPE.CONTROL;
			break;
		case campaignId.bannerOnMobile:
			getHash = window.cchome.util.murmurHashUserId('BANNER_ON_MOBILE');
			variation = findVariation(getHash);
			break;
		case campaignId.kaizenInstallerWaitTime:
			variation = getVariationForKaizen();
	}
	_campaignVariationMap[campaign] = variation;
}

export function isTestActive(campaign: string) {
	// const kaizenNUJM1Countries = ['au', 'nz', 'in', 'th', 'id', 'za', 'sg', 'ph', 'us'];
	// const countryCode = window.adobeIMS && window.adobeIMS.getUserProfile && window.adobeIMS.getUserProfile() && window.adobeIMS.getUserProfile().countryCode;

	switch (campaign) {
		case 'dummyTest': // For TestUtils test cases
			return AppsUtil.hasFeature('temp_dummy_test');
		case campaignId.growthIntentSelection:
			return AppsUtil.hasFeature('temp_enable_throughline_workflow')
				&& AppsUtil.hasFeature('temp_enable_throughline_v1_workflow')
				&& AppsUtil.getPathData().mainAppsTab !== 'download'
				&& AppsUtil.isUserEligibleForThroughline();
		case campaignId.growthIntentSelectionPhotoshop:
			return AppsUtil.hasFeature('temp_enable_throughline_workflow')
				&& AppsUtil.hasFeature('temp_enable_throughline_singlePs')
				&& AppsUtil.getPathData().mainAppsTab !== 'download'
				&& !AppsUtil.isMobileOrTab()
				&& AppsUtil.isUserEligibleForThroughlineSinglePs();
		case campaignId.throughlineV3En:
			return AppsUtil.hasFeature('temp_enable_throughline_workflow')
				&& AppsUtil.hasFeature('temp_enable_throughline_v3_workflow')
				&& AppsUtil.getPathData().mainAppsTab !== 'download'
				&& !AppsUtil.isMobileOrTab()
				&& !(isTestActive(campaignId.nujM3Test) && isTestExperience(campaignId.nujM3Test))
				&& AppsUtil.isUserEligibleForThroughlineV3EnLocale();
		case campaignId.throughlineV3Ja:
			return AppsUtil.hasFeature('temp_enable_throughline_workflow')
				&& AppsUtil.hasFeature('temp_enable_throughline_v3_workflow')
				&& AppsUtil.getPathData().mainAppsTab !== 'download'
				&& !AppsUtil.isMobileOrTab()
				&& AppsUtil.isUserEligibleForThroughlineV3JaLocale();
		case campaignId.nujM3Test:
			return AppsUtil.hasFeature('temp_nuj_m3_fg_changes')
				&& (_getVariationForCampaign(campaign) === VARIATION_TYPE.TEST
					|| _getVariationForCampaign(campaign) === VARIATION_TYPE.CONTROL);
		case campaignId.trialToTWPFree:
			return AppsUtil.hasFeature('temp_cch_8203_free')
				&& (_getVariationForCampaign(campaign) === VARIATION_TYPE.TEST
					|| _getVariationForCampaign(campaign) === VARIATION_TYPE.CONTROL);
		case campaignId.trialToTWPPaid:
			return AppsUtil.hasFeature('temp_cch_8203_paid')
				&& (_getVariationForCampaign(campaign) === VARIATION_TYPE.TEST
					|| _getVariationForCampaign(campaign) === VARIATION_TYPE.CONTROL);
		case campaignId.nujM3AllAppsTest:
			return AppsUtil.hasFeature('temp_nuj_m3_all_apps_changes')
				&& (_getVariationForCampaign(campaign) === VARIATION_TYPE.TEST
					|| _getVariationForCampaign(campaign) === VARIATION_TYPE.CONTROL);
		case campaignId.nujM3PhotoPlanTest:
			return AppsUtil.hasFeature('temp_nuj_m3_photo_plan_changes')
				&& (_getVariationForCampaign(campaign) === VARIATION_TYPE.TEST
					|| _getVariationForCampaign(campaign) === VARIATION_TYPE.CONTROL);
		case campaignId.categoryPageRevampTest:
			return AppsUtil.hasFeature('temp_test_category_revamp')
				&& AppsUtil.isUserEligibleForCategoryRevamp()
				&& !isTestActive(campaignId.nujM3Test)
				&& !isTestActive(campaignId.nujM3PhotoPlanTest)
				&& (_getVariationForCampaign(campaign) === VARIATION_TYPE.TEST
					|| _getVariationForCampaign(campaign) === VARIATION_TYPE.CONTROL);
		case campaignId.bannerOnMobile:
			return AppsUtil.hasFeature('temp_cch_10455')
				&& DeviceDetectionUtil.isTouchDevice()
				&& window.innerWidth < 481;
		case campaignId.kaizenInstallerWaitTime:
			return AppsUtil.hasFeature('temp_cch_11582_testA')
				|| AppsUtil.hasFeature('temp_cch_11582_testB');
		default :
			return false;
	}
}

export function _getVariationForCampaign(campaign: string) {
	if (!_campaignVariationMap[campaign]) {
		_initVariationForCampaign(campaign);
	}
	return _campaignVariationMap[campaign];
}

export function getExperienceForCampaign(campaign: string) {
	return _campaignExperienceMap[campaign] ? _campaignExperienceMap[campaign] : EXPERIENCE_TYPE.NA;
}

export function isTestAExperience(campaign: string) {
	return isTestActive(campaign) && _getVariationForCampaign(campaign) === VARIATION_TYPE.TEST_A;
}

export function isTestBExperience(campaign: string) {
	return isTestActive(campaign) && _getVariationForCampaign(campaign) === VARIATION_TYPE.TEST_B;
}

export function isTestExperience(campaign: string) {
	return isTestActive(campaign) && _getVariationForCampaign(campaign) === VARIATION_TYPE.TEST;
}

export function isControlExperience(campaign: string) {
	return isTestActive(campaign) && _getVariationForCampaign(campaign) === VARIATION_TYPE.CONTROL;
}

// applicable only for banner events right now.
export function setExpCampaignAndVariationFromSophia(dataObject: Object, campaignId: string, variationId: string, experienceId: string) {
	const varId = `${campaignId}:${variationId || VARIATION_TYPE.NA}`;
	const expId = `${campaignId}:${experienceId || EXPERIENCE_TYPE.NA}`;
	dataObject.setExpCampaignID = dataObject.setExpCampaignID ? `${dataObject.setExpCampaignID}|${campaignId}` : campaignId;
	dataObject.setExpVariationID = dataObject.setExpVariationID ? `${dataObject.setExpVariationID}|${varId}` : variationId;
	dataObject.setExpExperienceID = dataObject.setExpExperienceID ? `${dataObject.setExpExperienceID}|${expId}` : experienceId;
}

export function setExpCampaignAndVariation(dataObject: Object) {
	let expCampaignId = '';
	let expVariationId = '';
	let expExperienceId = '';

	const campaigns = {...campaignId, ...variableCampaign};
	Object.keys(campaigns).forEach((campaign) => {
		const compaignName = campaigns[campaign];
		if (isTestActive(compaignName) || variableCampaign[campaign]) {
			if (expCampaignId !== '' && expVariationId !== '' && expExperienceId !== '') {
				expCampaignId += '|';
				expVariationId += '|';
				expExperienceId += '|';
			}
			expCampaignId += compaignName;
			expVariationId += `${_getVariationForCampaign(compaignName)}:${compaignName}`;
			expExperienceId += `${getExperienceForCampaign(compaignName)}:${compaignName}`;
		}
	});
	if (expCampaignId !== '' && expVariationId !== '' && expExperienceId !== '') {
		dataObject.setExpCampaignID = expCampaignId;
		dataObject.setExpVariationID = expVariationId.includes('|') ? expVariationId : _getVariationForCampaign(expCampaignId);
		dataObject.setExpExperienceID = expExperienceId.includes('|') ? expExperienceId : getExperienceForCampaign(expCampaignId);
	}
}

export function addVariableCampaign(campaign: string) {
	variableCampaign[campaign] = campaign;
}

export function setCampaignVariationMapWithFGTests(campaign: string, variation: string) {
	_campaignVariationMap[campaign] = variation;
}

export function setCampaignExperienceMapWithFGTests(campaign: string, experience: string) {
	_campaignExperienceMap[campaign] = experience;
}
